let store = require("../store");
let actions = require("../actions");

let Pulse = mc.widgets.Pulse;

class ArchiveView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      waiting: null,
      study: store.getState().study[props.studyId]
    };
  }

  componentDidMount() {
    this.unsubscribe = store.subscribe(this.handleStoreChange.bind(this));

    actions.loadStudy(this.props.studyId);
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  handleStoreChange() {
    this.setState({
      study: store.getState().study[this.props.studyId]
    });
  }

  downloadArchive() {
    let study = this.state.study;

    actions.downloadArchive(study.export.href).then(function (payload) {
      location.href = payload.href;
      mc.ui.modal(null);
    });
  }

  requestArchive() {
    let wait = mc.ui.wait(1000);

    this.setState({ waiting: true });

    Promise.all([actions.requestArchive(this.props.studyId), wait]).then((function () {
      this.setState({ waiting: false });
    }).bind(this));
  }

  static open(studyId) {
    let opts = {
      width: "400px",
      height: "250px",
      verticalAlign: "center"
    };

    mc.ui.modal(<ArchiveView studyId={studyId}/>, opts);
  }

  render() {
    let { study, waiting } = this.state;
    let archive = study.export;
    let content;

    if (waiting === true) {
      content = <Pulse/>;
    }
    else if (waiting === false) {
      content = <p>{tx("generating_export_file")}</p>;
    }
    else {
      content = (
        <div>
          <img src="./img/rc/archive.svg" width="70" height="70"/>
          {
            archive && (
              <div>
                <p>{tx("file_generated_at", { date: mc.format.datetime(archive.requestedTs) })}</p>
                <p>
                  <a onClick={this.downloadArchive.bind(this)}>
                    <b>{tx("download_file", { size: mc.format.filesize(archive.sizeBytes) })}</b>
                  </a>
                </p>
              </div>
            )
          }
          <p>
            <a onClick={this.requestArchive.bind(this)}>{tx("request_export_file")}</a>
          </p>
        </div>
      );
    }

    return (
      <div className="rc-archive-view">
        {content}
      </div>
    );
  }
}

module.exports = ArchiveView;